import styled from "styled-components";
import {
  Button,
  colors,
  screenSizes,
  typography
} from "@streeteasy/design-system";
import { visuallyHiddenCss } from "@streeteasy/design-system/style-utilities/visually-hidden";

import SEModal from "../../../../shared/components/SEModal";
import { mapWithPin } from "../../assets";

const { BRAND, GRAY, GRAY_LIGHT } = colors;
const { LARGE_SCREEN } = screenSizes;
const { Caps, H3 } = typography;

const contentPadding = 24;
const labelHeight = 22;

const addDialogStyles = ({ dimensions }) => ({
  dialogStyles: {
    left: `${dimensions.left - contentPadding}px`,
    top: `${dimensions.top - contentPadding - labelHeight}px`,
    width: `${dimensions.width + contentPadding * 2}px`
  }
});

export const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
`;

export const Modal = styled(SEModal).attrs(addDialogStyles)`
  @media screen and (max-width: ${LARGE_SCREEN}px) {
    height: 100%;
    margin-top: 0;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
  }
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 320px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    height: 100%;
  }
`;

export const Title = styled(H3)`
  ${visuallyHiddenCss};

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    clip: auto;
    display: block;
    height: auto;
    margin-bottom: 32px;
    margin-top: 4px;
    position: static;
    visibility: visible;
    width: auto;
  }
`;

export const Content = styled.div`
  padding: 18px ${contentPadding}px 16px;
`;

export const Footer = styled.div`
  border-top: 1px solid ${GRAY_LIGHT};
  display: flex;
  margin-top: auto;
  padding: 16px 24px 16px 18px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    padding-bottom: 150px;
  }
`;

export const Apply = styled(Button).attrs({
  type: "button"
})`
  flex: 1;
`;

export const Reset = styled(Caps).attrs({
  as: "button",
  type: "button"
})`
  background: none;
  border: none;
  margin-right: 16px;
  color: ${BRAND};

  &:disabled {
    color: ${GRAY};
  }
`;

export const MapModalButton = styled.button.attrs({
  type: "button"
})`
  align-items: center;
  background: none;
  border: none;
  border-top: 1px solid ${GRAY_LIGHT};
  color: ${BRAND};
  display: flex;
  font-size: 14px;
  justify-content: center;
  margin: auto 24px 0;
  padding: 16px 0;

  + ${Footer} {
    margin-top: 0;
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    margin: 0 24px;
  }
`;

export const MapModalIcon = styled.i.attrs({
  role: "presentation"
})`
  background: url(${mapWithPin});
  background-repeat: no-repeat;
  display: inline-block;
  margin-right: 6px;
  height: 21px;
  width: 26px;
`;
